export default {
  SET_SAVED_PM(state, data) {
    state.savedPm = data
  },
  SET_DATA_PM(state, data) {
    state.pm = data.datas
    state.totalPm = data.total
  },
  SET_URGENT_CAMPAIGN(state, data) {
    state.urgentCampaign = data
    state.totalUrgentCampaign = data.length
  },
  SET_DATA (state, data) {
    state.campaign = data.datas
    state.totalCampaign = data.total
  },
  SET_DATA_URGENT (state, data) {
    state.urgentCampaign = data.datas
    state.totalUrgentCampaign = data.total
  },
  SET_POPULAR (state, limit) {
    state.popularCampaign = state.campaign.slice().splice(0, limit)
  },
  SET_DETAIL (state, id) {
    state.campaign.forEach(item => {
      if (item.id == id) {
				
      }
    })
  },
  SET_TRANSACTION_PRODUCT (state, val) {
    state.transactionProduct = val
  },
  SET_TRANSACTION_PAYMENT (state, val) {
    state.transactionPayment = val
  },
  SET_TYPE_TRANSACTION (state, val) {
    state.transactionTypes = val
  },
  SET_HISTORY_TRANSACTION (state, val) {
    state.transactionHistory = val
  },
  SET_TRANSACTION_AMOUNT (state, amount) {
    state.transactionAmount = amount
  },
  SET_DATA_ZXCARE(state, data) {
    state.zxCareCampaign = data.datas
    state.totalZxCareCampaign = data.total
  },
  SET_CATEGORY_CAMPAIGN(state, payload) {
    state.categoryCampaign = payload.datas
    state.totalCategoryCampaign = payload.total
  },
  SET_SEARCH_CAMPAIGN(state, payload) {
    state.searchCampaign = payload.datas
    state.totalSearchCampaign = payload.total
  },
  SET_SAHABAT_CAMPAIGN(state, payload) {
    state.sahabatCampaign = payload.datas
    state.totalSahabatCampaign = payload.total
  },
  DELETE_TRANSACTION_PRODUCT(state) {
    state.transactionProduct = null
  },
  DELETE_TRANSACTION_PAYMENT(state) {
    state.transactionPayment = null
  },
  DELETE_TRANSACTION_AMOUNT(state) {
    state.transactionAmount = 0
  },
  DELETE_TRANSACTION_TYPES(state) {
    state.transactionTypes = []
  },
  DELETE_TRANSACTION_HISTORY(state) {
    state.transactionHistory = null
  },
  REMOVE_DATA_PM(state) {
    state.savedPm = null;
  }
}